import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Appconfig from "../../config/config";
import Helper from "../../helper";

function ProfitLossBetHistory() {
  const params = useParams();
  const userInfo = Helper();

  const [filteredData, setFilteredData] = useState([]);

  const [formData] = useState({
    user_id: userInfo && userInfo?._id,
    match_id: params?.match_id,
    market_name: params?.market_name,
    market_id: params?.market_id,
    event_type: params?.event_type_id,
    from_date: params?.from_date,
    to_date: params?.to_date,
  });

  useEffect(() => {
    filterProfitLossBetHistory();
  }, []);

  const filterProfitLossBetHistory = async () => {
    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}reports/auraProfitLossBetHistory`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      setFilteredData(response.data.resultData || []);
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Render table rows like AccountStatement
  const renderRows = () => {
    if (filteredData && filteredData.length > 0) {
      return filteredData.map((record, index) => (
        <tr
          key={index}
          className="text-sm font-medium bg-white hover:bg-[#f1faf7] transition"
        >
          {/* Sport Name */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record.event_type == 4
              ? "Cricket"
              : record.event_type == 2
              ? "Tennis"
              : record.event_type == 1
              ? "Soccer"
              : record.event_type == 777
              ? "WCO Casino"
              : record.event_type == 7
              ? "Horse Racing"
              : [1004, 1005, 1007, 1008, 1009].includes(record.event_type)
              ? "Casino"
              : record.event_type == 4339
              ? "Greyhound Racing"
              : record.event_type == 27979456
              ? "Kabaddi"
              : record.event_type == 7522
              ? "Basketball"
              : record.event_type == 2378961
              ? "Politics"
              : record.event_type == 66101
              ? "Virtual"
              : record.event_type == 66104
              ? "Lottery"
              : "Casino"}
          </td>

          {/* Event Name */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777"
              ? record?.remarks.split("(")[0].trim()
              : record?.event_name}
          </td>

          {/* Market Name */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777" ? record?.game_code : record?.market_name}
          </td>

          {/* Selection Name */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777" ? "-" : record?.runner_name}
          </td>

          {/* Bet Type */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record.event_type == "777" ? (
              record?.transaction_type
            ) : record.is_back ? (
              <span className="text-green-600 font-bold">BACK</span>
            ) : (
              <span className="text-red-600 font-bold">LAY</span>
            )}
          </td>

          {/* User Price */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777" ? "-" : record?.price_val}
          </td>

          {/* Amount */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777" ? "-" : record?.stake}
          </td>

          {/* Profit / Loss */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {record?.event_type == "777" ? (
              <span
                className={`font-bold ${
                  record.transaction_type === "Debit"
                    ? "text-red-600"
                    : "text-green-600"
                }`}
              >
                {record?.amount?.toFixed(2)}
              </span>
            ) : (
              <span
                className={`font-bold ${
                  record.totalPL < 0 ? "text-red-600" : "text-green-600"
                }`}
              >
                {record?.totalPL?.toFixed(2)}
              </span>
            )}
          </td>

          {/* Place Date */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {new Date(record.createdAt).toLocaleString()}
          </td>

          {/* Match Date */}
          <td className="px-4 py-3 text-center border border-gray-200">
            {new Date(record.createdAt).toLocaleString()}
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td
            colSpan="10"
            className="px-4 py-6 text-center text-gray-500 italic bg-white border border-gray-200"
          >
            No records found
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      {/* Header */}
      <div className="account-statment p-6">
        <h2 className="text-2xl font-bold text-[#0c9971] mb-2">
          Profit / Loss Bet History
        </h2>
      </div>

      {/* Tailwind Table */}
      <div className="table-container mx-2 bg-white rounded-2xl shadow-md p-4">
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 border-collapse rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-[#0c9971] to-[#0a7d5c] text-white text-sm">
                <th className="px-4 py-3 text-center border border-gray-200">
                  Sport
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Event
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Market
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Selection
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Bet Type
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Price
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Amount
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Profit / Loss
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Place Date
                </th>
                <th className="px-4 py-3 text-center border border-gray-200">
                  Match Date
                </th>
              </tr>
            </thead>
            <tbody>{renderRows()}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ProfitLossBetHistory;
